import React from "react";

// Shared address renderer — extracted Feb 2026 from
// LotSubmittedViewerDialog so the Dispatch.js create/edit dialog can
// reuse the exact "compact conditionally-rendered read-only" layout
// (fields with no value skipped entirely; City/State/Pincode grouped
// onto one line). Preserves per-field testids only when the underlying
// value is present (`${prefix}-label` / `-gstin` / `-contact-name` /
// `-contact-phone` / `-line1` / `-line2` / `-city` / `-country`).
export default function AddressBlock({ label, addr, testIdPrefix }) {
  const a = addr || {};
  const cityLine = [a.city, a.state].filter(Boolean).join(", ");
  const cityLineFull = a.pincode ? (cityLine ? `${cityLine} — ${a.pincode}` : a.pincode) : cityLine;
  const rows = [
    ["label", "Label", a.label],
    ["gstin", "GSTIN", a.gstin],
    ["contact-name", "Contact", a.contact_name],
    ["contact-phone", "Phone", a.contact_phone],
    ["line1", "Line 1", a.line1],
    ["line2", "Line 2", a.line2],
    ["city", "City / State / Pincode", cityLineFull],
    ["country", "Country", a.country],
  ].filter(([, , v]) => v && String(v).trim());
  return (
    <div
      className="border border-zinc-200 rounded-sm p-3 bg-zinc-50/60 text-sm"
      data-testid={`${testIdPrefix}-block`}
    >
      <div className="text-xs font-mono uppercase text-zinc-500 mb-2">{label}</div>
      {rows.length === 0 ? (
        <div className="text-xs italic text-zinc-400">No address captured.</div>
      ) : (
        <dl className="grid grid-cols-[max-content_1fr] gap-x-3 gap-y-1">
          {rows.map(([tid, lbl, val]) => (
            <React.Fragment key={tid}>
              <dt className="text-[11px] text-zinc-500 pt-[1px]">{lbl}</dt>
              <dd
                className="text-zinc-800 font-mono text-[13px] break-words"
                data-testid={`${testIdPrefix}-${tid}`}
              >
                {val}
              </dd>
            </React.Fragment>
          ))}
        </dl>
      )}
    </div>
  );
}
